module.exports = __webpack_public_path__ + "img/roboport-door-up.8d76e724.png";